module.exports = __webpack_public_path__ + "img/designguide_2@2x.b9e08ef.webp";